
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/aplicacoes/[slug]",
      function () {
        return require("private-next-pages/aplicacoes/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/aplicacoes/[slug]"])
      });
    }
  